import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link className="logoContainer" to="/">
      <img className="logo" src="/logo.jpg" alt="logo" />
    </Link>
  );
};

export default Logo;
